import React from 'react'
import { Outlet } from 'react-router-dom'

function MainContracts() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainContracts
